import React, {useState} from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/cjs/Page/AnnotationLayer.css';
import { pdfjs } from 'react-pdf';
import './pdf.css';
import AppBar from "@mui/material/AppBar";
import {Dialog, IconButton} from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
).toString();

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// Create Document Component
const PdfDocument = ({file, handleClose}) => {
    const [pageNumber, setPageNumber] = useState(1);

    return (
        <Dialog
            fullScreen
            open={!!file}
            onClose={handleClose}
            TransitionComponent={Transition}
        >
            <AppBar sx={{ position: 'relative', marginBottom: "1rem" }} color="secondary">
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Document file={file} >
                <Page pageNumber={pageNumber} />
            </Document>
        </Dialog>
    );
}


export default PdfDocument;
